module.exports = __webpack_public_path__ + "static/media/fly0001.6f56a0c6.webp";